import React, { useState } from "react";
import { Link } from "react-scroll";
import "./Navbar.css";

const Navbar = () => {
  const [click, setClick] = useState(true);

  const handleClick = () => setClick(!click);

  return (
    <>
      <div>
        <div className="main-nav">
          <nav class="nav-link">
            <Link
              className="Link"
              to="home"
              activeClass="linkActive"
              spy={true}
              smooth={"easeOutCubic"}
              hashSpy={true}
              duration={700}
            >
              home
            </Link>

        

            <Link
              className="Link"
              to="about"
              activeClass="linkActive"
              spy={true}
              smooth={"easeOutCubic"}
              hashSpy={true}
              duration={700}
            >
              about
            </Link>

            <Link
              className="Link"
              to="skills"
              activeClass="linkActive"
              spy={true}
              smooth={"easeOutCubic"}
              hashSpy={true}
              duration={700}
            >
              skills
            </Link>

            <Link
              className="Link"
              to="services"
              activeClass="linkActive"
              spy={true}
              smooth={"easeOutCubic"}
              hashSpy={true}
              duration={700}
            >
              services
            </Link>

            <Link
              className="Link"
              to="portfolio"
              activeClass="linkActive"
              spy={true}
              smooth={"easeOutCubic"}
              hashSpy={true}
              duration={700}
            >
              portfolio
            </Link>

            <Link
              className="Link"
              to="blogs"
              activeClass="linkActive"
              spy={true}
              smooth={"easeOutCubic"}
              hashSpy={true}
              duration={700}
            >
              blogs
            </Link>

            <Link
              className="Link"
              to="contact"
              activeClass="linkActive"
              spy={true}
              smooth={"easeOutCubic"}
              hashSpy={true}
              duration={700}
            >
              contact
            </Link>
          </nav>
        </div>
      </div>

      {/* responsive nav  */}

      <div className="res-nav-bar">
        <div>
          <div
            className={click ? "menu-btn" : "menu-btn open"}
            onClick={handleClick}
          >
            <div className="menu-btn__burger"></div>
          </div>
          <div className="nav-body">
            <nav className={click ? "nav-link" : "nav-link close"}>
              <Link
                onClick={handleClick}
                className="Link"
                to="home"
                activeClass="linkActive"
                spy={true}
                smooth={"easeOutCubic"}
                hashSpy={true}
                duration={700}
              >
                home
              </Link>

              <Link
                onClick={handleClick}
                className="Link"
                to="about"
                activeClass="linkActive"
                spy={true}
                smooth={"easeOutCubic"}
                hashSpy={true}
                duration={700}
              >
                about
              </Link>

              <Link
                onClick={handleClick}
                className="Link"
                to="skills"
                activeClass="linkActive"
                spy={true}
                smooth={"easeOutCubic"}
                hashSpy={true}
                duration={700}
              >
                skills
              </Link>

              <Link
                onClick={handleClick}
                className="Link"
                to="services"
                activeClass="linkActive"
                spy={true}
                smooth={"easeOutCubic"}
                hashSpy={true}
                duration={700}
              >
                services
              </Link>

              <Link
                onClick={handleClick}
                className="Link"
                to="portfolio"
                activeClass="linkActive"
                spy={true}
                smooth={"easeOutCubic"}
                hashSpy={true}
                duration={700}
              >
                portfolio
              </Link>

              <Link
                onClick={handleClick}
                className="Link"
                to="blogs"
                activeClass="linkActive"
                spy={true}
                smooth={"easeOutCubic"}
                hashSpy={true}
                duration={700}
              >
                blogs
              </Link>

              <Link
                onClick={handleClick}
                className="Link"
                to="contact"
                activeClass="linkActive"
                spy={true}
                smooth={"easeOutCubic"}
                hashSpy={true}
                duration={700}
              >
                contact
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
